import { UID } from './types';

export enum ActionTimescaleFrom {
  assessedDate = 'assessedDate',
  approvedDate = 'approvedDate',
}

export enum AseTemplateOptionPdfActionsControls {
  actionsControls = 'actionsControls',
  controlsActions = 'controlsActions',
  actions = 'actions',
  controls = 'controls',
  none = 'none',
}

export type AseSetupFlag = {
  id: UID;
  name: string;
  description: string;
  setInProgress: boolean;
  setSubmitted: boolean;
  setApproved: boolean;
  showOnReport: boolean;
};

export type AseSetupSignatory = {
  id: UID;
  name: string;
  declaration: string;
  requireOnSubmit: boolean;
  allowUnavailable: boolean;
  ordering: number;
};
